import React, { Component } from 'react'
import PropTypes from 'prop-types'

import InnerImageZoom from 'react-inner-image-zoom'

import HeaderPage from './../block/HeaderPage'
import Breadcrumbs from './../block/Breadcrumbs'
import RecomendedNg from './../block/RecomendedNg'
import Shops from './../block/ShopsProductPage'
import Razmeri from './../block/RazmeriProductPage'
import Lists from './../block/ListsProductPage'
import FeedbackForm from './../block/FeedbackForm'

import { Spinner, Image, Container, Button, ButtonGroup } from 'react-bootstrap'

import { Swiper, SwiperSlide } from 'swiper/react'

import 'swiper/css'
import 'swiper/css/navigation'
import 'swiper/css/thumbs'

import { Navigation, Thumbs } from 'swiper/modules'

import styles from './../blocks.module.sass'

import './../styles.min.css'

export default class Main extends Component {

  constructor(props) {
    super(props)

    const { ajax_data, get } = props

    var search_arr = {
      product_id: get?.product_id || '',
      variant_id: get?.variant_id || ''
    }

    var product = null

    var productData = {
      product: null,
      variant: null,
      stocks: {
        sklad: 0,
        shop: 0
      },
      color: ``,
      size: ``,
      count: 0,
      list_colors: []
    }

    if('products' in ajax_data) {
      let find = false
      if( search_arr.product_id != '' ) {
        ajax_data.products.map( ( product_el ) => {
          if( product_el.msid == search_arr.product_id ) {
            product = product_el
            find = true
          }
        })
      }
      if(!find) {
        product = ajax_data.products[0]
        if(ajax_data?.product_msid != '') {
          ajax_data.products.map( ( product_el ) => {
            if( product_el.msid == ajax_data?.product_msid ) {
              product = product_el
              find = true
            }
          })
        }
      }
      if(product.variants != null) {
        if( search_arr.variant_id != '' ) {
          let find = false
          product.variants.map( ( variant ) => {
            if( variant.msid == search_arr.variant_id ) find = true
          } )
          if(find) {
            productData = this.getProduct( product.msid, search_arr.variant_id )
          } else {
            productData = this.getProduct( product.msid, product.variants[0].msid )
          }
        } else {
          productData = this.getProduct( product.msid, product.variants[0].msid )
        }
      } else {
        productData = this.getProduct( product.msid, null )
      }
    }

    this.state = {
      product: productData.product,
      variant: productData.variant,
      stocks: productData.stocks,
      color: productData.color,
      size: productData.size,
      count: productData.count,
      list_colors: productData.list_colors,
      thumbsSwiper: 0,
      description: false,
      show_feedback: false,
      client: false
    }

  }

  show_feedback() {
    this.setState({
      show_feedback: true
    })
  }
  close_feedback = () => {
    this.setState({
      show_feedback: false
    })
  }

  changeDescription = () => {
    this.setState({
      description: !this.state.description
    })
  }

  priceFormat(price, delimiter, fraction) {
    if(price == 0 || price == '') return 0
    fraction = [0,1,2].indexOf(fraction) !== -1 ? fraction : 0
    delimiter = delimiter || ' '
    price = (price = parseFloat(price)) && isFinite(price) && price.toFixed(fraction) || false
    if (price === false) throw new TypeError('Price should be a valid integer.')
    var reverseString = function(string) {
        return string.split('').reverse().join('')
    }
    return reverseString(reverseString(price).replace(/(\d{3})/g, '$&' + delimiter))
  }

  setThumbsSwiper = ( k ) => {
    this.setState({
      thumbsSwiper: k
    })
  }

  getProduct = ( prduct_msid, variant_msid ) => {

    const { page_data, ajax_data, cart } = this.props

    var product = null,
    variant = null,
    stocks = {
      sklad: 0,
      shop: 0
    },
    color = ``,
    size = ``,
    count = 0,
    list_colors = []

    if('products' in ajax_data) {

      ajax_data.products.map( ( elm ) => {
        if( elm.msid == prduct_msid ) product = elm
      })
      if(product.variants != null) {
        product.variants.map( ( elm ) => {
          if( elm.msid == variant_msid ) variant = elm
        })
      }

      if( product != null) {
        if( variant != null ) {
          if('stocks' in variant && variant.stocks != null) {
            variant.stocks.map( ( elm ) => {
              if( page_data.stock_shops.includes( elm.name ) ) {
                stocks.shop+= elm.stock
              } else if( page_data.stock_bystore.includes( elm.name ) ) stocks.sklad+= elm.stock
            })
          }
          color = variant.colorName
          size = variant.size

          cart.map( ( elm ) => {
            if( elm.resource == ajax_data.id && elm.product == product.msid && elm.variant == variant.msid ) count = elm.count
          })

        } else {
          if( 'stocks' in product && product.stocks != null ) {
            product.stocks.map( ( elm ) => {
              if( page_data.stock_shops.includes( elm.name ) ) {
                stocks.shop+= elm.stock
              } else if( page_data.stock_bystore.includes( elm.name ) ) stocks.sklad+= elm.stock
            })
          }

          cart.map( ( elm ) => {
            if( elm.resource == ajax_data.id && elm.product == product.msid && elm.variant == null ) count = elm.count
          })
        }

        var u_colors = [], u_colors2 = []
        ajax_data.products.map(( prod ) => {
          if(prod.variants != null) prod.variants.sort( ( a, b ) => a.colorName.localeCompare( b.colorName, 'ru' )).map(( elm ) => {
            if(!u_colors.includes( prod.msid )) {
              u_colors.push( prod.msid )
              list_colors.push({
                color: elm.color,
                name: u_colors2.includes( elm.colorName ) ? elm.colorName + ` ( Арт. ` + prod.article + ` )` : elm.colorName,
                product: prod.msid,
                variant: elm.msid,
                article: prod.article
              })
              u_colors2.push( elm.colorName )
            }
          })
        })
      }
    }

    return {
      product: product,
      variant: variant,
      stocks: stocks,
      color: color,
      size: size,
      list_colors: list_colors,
      count: count
    }
  }

  changeProduct = ( prduct_msid, variant_msid ) => {
    const res = this.getProduct( prduct_msid, variant_msid )
    this.setState({
      product: res.product,
      variant: res.variant,
      stocks: res.stocks,
      color: res.color,
      size: res.size,
      list_colors: res.list_colors,
      count: res.count
    })
  }

  addTocart = ( count = 1 ) => {
    const { ajax_data, addTocart } = this.props,
    { product, variant } = this.state

    if(variant != null) {
      addTocart({
        resource: ajax_data.id,
        product: product.msid,
        variant: variant.msid,
        count: count
      })
    } else {
      addTocart({
        resource: ajax_data.id,
        product: product.msid,
        variant: null,
        count: count
      })
    }
    this.setState({
      count: count
    })
  }

  changeCount = ( count ) => {
    const { stocks } = this.state

    if( count < 0 ) count = 0
    if( count > ( stocks.sklad + stocks.shop ) ) count = stocks.sklad + stocks.shop
    this.addTocart( count )
  }

  componentDidMount() {
    this.setState({
      client: true
    })
  }

  render() {

    const { ajax_data, page_data, changeTopSearch, changeLeftMenuh, showInCart, favorite, changeFavorite, cart, in_cart_loading, clientWidth } = this.props,
    { product, variant, thumbsSwiper, stocks, description, color, size, list_colors, count, show_feedback, client } = this.state,

    text_v_magazine = (
      <div className={styles.block_product_start_stock}>
        <div className='d-flex align-items-start'>
          <svg width="14" height="15" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M3.10938 6.11508L6.29155 9.35349L10.888 4.67578" stroke="black" strokeWidth="0.75"/>
            <rect x="0.375" y="0.375" width="13.25" height="13.2816" rx="6.625" stroke="black" strokeWidth="0.75"/>
          </svg>
          <div>Только в магазине</div>
        </div>
      </div>
    ),
    text_net_vnalichii = (
      <div className={styles.block_product_start_stock}>
        <div className='d-flex align-items-start'>
          <svg width="14" height="15" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="0.375" y="0.375" width="13.25" height="13.2816" rx="6.625" stroke="black" strokeWidth="0.75"/>
            <path d="M4 4L10 10" stroke="black"/>
            <path d="M10 4L4 10" stroke="black"/>
          </svg>
          <div>
            <div>Нет в наличии</div>
            <div className={styles.block_product_start_stock_sub}>Мы уведомим вас о появлении товара</div>
          </div>
        </div>
      </div>
    ),
    text_vnalichii = (
      <div className={styles.block_product_start_stock}>
        <div className='d-flex align-items-start'>
          <svg width="14" height="14" viewBox="0 0 11 11" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M3 4.92308L5.04545 7L8 4" stroke="black" strokeWidth="0.75"/>
            <rect x="0.375" y="0.375" width="10.25" height="10.25" rx="5.125" stroke="black" strokeWidth="0.75"/>
          </svg>
          <div>
            <div>В наличии</div>
          </div>
        </div>
      </div>
    ),
    u_sizes = []

    return (
      <>
        <HeaderPage
          ajax_data={ajax_data}
          page_data={page_data}
          changeTopSearch={changeTopSearch}
          changeLeftMenuh={changeLeftMenuh}
          favorite={favorite}
          cart={cart}
        />
        <div className='w-100' style={{ flex: 1 }}>
          {ajax_data != null ?
            <div>
              <Container>
                {'bc' in ajax_data &&
                  <Breadcrumbs
                    pages={[
                      ...ajax_data.bc,
                      {
                        name: ajax_data.longtitle ? ajax_data.longtitle : ajax_data.pagetitle,
                        current: true
                      }
                    ]}
                  />
                }
                {product != null &&
                  <div className={styles.block_product}>
                    <div className={styles.block_product_start}>
                      {product.images != null &&
                        <>
                          {clientWidth >= 1450 &&
                            <Swiper
                              onSwiper={this.setThumbsSwiper}
                              direction={'vertical'}
                              slidesPerView={5}
                              spaceBetween={20}
                              className={styles.block_product_lslyder + ' d-none d-xl-block'}
                              modules={[Thumbs]}
                            >
                              {product.images.map( ( src, k ) => {
                                return (
                                  <SwiperSlide key={k} className={styles.block_product_lslyder_el}>
                                    <Image src={src} width="138" height="138" />
                                  </SwiperSlide>
                                )
                              } )}
                            </Swiper>
                          }
                          <div>
                            <Swiper
                              navigation={true}
                              thumbs={{ swiper: thumbsSwiper }}
                              modules={[Navigation, Thumbs]}
                              className={styles.block_product_rslyder + ` block_product_rslyder`}
                            >
                              {product.images.map( ( src, k ) => {
                                return (
                                  <SwiperSlide key={k} className={styles.block_product_rslyder_el}>
                                  {client ? (
                                    <InnerImageZoom src={src} zoomSrc={src} width="533" height="770" />
                                  ) : (
                                    <Image src={src} width="533" height="770" />
                                  )}
                                  </SwiperSlide>
                                )
                              } )}
                              {'products' in ajax_data &&
                                <div className={styles.block_product_rslyder_favorite}>
                                  <svg onClick={() => changeFavorite( ajax_data.products[0].msid )} width="12" height="17" viewBox="0 0 12 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M0 3.2002V12.6854C0 14.0464 0 14.7268 0.204119 15.1433C0.582446 15.9151 1.41157 16.3588 2.26367 16.2454C2.7234 16.1842 3.28964 15.8067 4.4221 15.0518L4.42481 15.0499C4.87368 14.7507 5.09815 14.6011 5.33295 14.5181C5.76421 14.3656 6.23476 14.3656 6.66602 14.5181C6.90129 14.6012 7.12664 14.7515 7.57732 15.0519C8.70978 15.8069 9.27665 16.1841 9.73638 16.2452C10.5885 16.3586 11.4176 15.9151 11.7959 15.1433C12 14.7269 12 14.0462 12 12.6854V3.19691C12 2.07899 12 1.5192 11.7822 1.0918C11.5905 0.715473 11.2837 0.409734 10.9074 0.217987C10.4796 0 9.9203 0 8.8002 0H3.2002C2.08009 0 1.51962 0 1.0918 0.217987C0.715473 0.409734 0.409734 0.715473 0.217987 1.0918C0 1.51962 0 2.08009 0 3.2002Z" fill={favorite.includes( ajax_data.products[0].msid ) ? `#FF0000` : `#F6F6F6`}/>
                                  </svg>
                                </div>
                              }
                            </Swiper>
                            {clientWidth < 1450 &&
                              <Swiper
                                onSwiper={this.setThumbsSwiper}
                                slidesPerView={`auto`}
                                spaceBetween={9}
                                className={styles.block_product_lslyder + ' d-xl-none'}
                                modules={[Thumbs]}
                              >
                                {product.images.map( ( src, k ) => {
                                  return (
                                    <SwiperSlide key={k} className={styles.block_product_lslyder_el}>
                                      <Image src={src} width="138" height="138" />
                                    </SwiperSlide>
                                  )
                                } )}
                              </Swiper>
                            }
                          </div>
                        </>
                      }
                      <div className={styles.block_product_start_text}>
                        {product.article != '' &&
                          <div className={styles.block_product_start_art}>Арт. {product.article}</div>
                        }
                        {variant != null ?
                          <>
                            <h1 className={styles.block_product_start_name}>{ajax_data.seo_h1}</h1>
                            <div className={stocks.sklad + stocks.shop == 0 ? styles.block_product_start_price_empty : styles.block_product_start_price}>
                              <div>
                                {variant?.old_price > variant.price ? (
                                  <>
                                    <s>{this.priceFormat(variant.old_price)}</s>{` `}
                                    <font color='red'>{this.priceFormat(variant.price)}</font>{` `}
                                    ₽
                                  </>
                                ) : (
                                  <>{this.priceFormat( variant.price )}{` `}₽</>
                                )}
                              </div>
                              {ajax_data.new && <Button className={styles.block_product_start_price_btn + ` text-light`} variant="danger">Новинка</Button>}
                            </div>
                            <div className={styles.block_product_start_stock}>
                              {stocks.sklad == 0 ?
                                <>
                                  {stocks.shop > 0 ?
                                    <>{text_v_magazine}</>
                                  :
                                    <>{text_net_vnalichii}</>
                                  }
                                </>
                              :
                                <>{text_vnalichii}</>
                              }
                            </div>
                          </>
                        :
                          <>
                            <h1 className={styles.block_product_start_name}>{ajax_data.seo_h1}</h1>
                            <div className={stocks.sklad + stocks.shop == 0 ? styles.block_product_start_price_empty : styles.block_product_start_price}>
                              <div>
                                {product?.old_price > product.price ? (
                                  <>
                                    <s>{this.priceFormat(product.old_price)}</s>{` `}
                                    <font color='red'>{this.priceFormat(product.price)}</font>{` `}
                                    ₽
                                  </>
                                ) : (
                                  <>{this.priceFormat( product.price )}{` `}₽</>
                                )}
                              </div>
                              {ajax_data.new && <Button className={styles.block_product_start_price_btn} variant="danger">Новинка</Button>}
                            </div>
                            <div className={styles.block_product_start_stock}>
                              {stocks.sklad == 0 ?
                                <>
                                  {stocks.shop > 0 ?
                                    <>{text_v_magazine}</>
                                  :
                                    <>{text_net_vnalichii}</>
                                  }
                                </>
                              :
                                <>{text_vnalichii}</>
                              }
                            </div>
                          </>
                        }
                        <div className={styles.block_product_start_description}>
                          <div onClick={() => this.changeDescription()} className='d-flex align-items-center justify-content-between'>
                            <div className={styles.block_product_start_description_title}>Описание</div>
                            <svg className={description ? styles.block_product_start_description_icon_open : styles.block_product_start_description_icon} width="12" height="7" viewBox="0 0 12 7" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M11 6L6 1L1 6" stroke="black"/>
                            </svg>
                          </div>
                          <div className={description ? styles.block_product_start_description_text_open : styles.block_product_start_description_text}>
                            {product.description}
                          </div>
                        </div>
                        {product.sostav != null &&
                          <div className={styles.block_product_start_description}>
                            <div className='d-flex align-items-center justify-content-between'>
                              <div className={styles.block_product_start_description_title}>Cостав</div>
                              <div></div>
                            </div>
                            <div className={styles.block_product_start_description_text}>
                              {product.sostav}
                            </div>
                          </div>
                        }
                        {'products' in ajax_data &&
                          <>
                            {variant != null &&
                              <>
                                <div className={styles.block_product_start_description}>
                                  <div className='d-flex align-items-center justify-content-between'>
                                    <div className={styles.block_product_start_description_title}>Цвет</div>
                                    <div></div>
                                  </div>
                                  <div className={styles.block_product_start_description_text}>
                                    {list_colors.map( ( elm, k ) => {
                                      return (
                                        <div title={`Арт. ` + elm.article} onClick={() => this.changeProduct( elm.product, elm.variant )} key={k} className={styles.block_product_color}>
                                          <div className={product.msid == elm.product ? styles.block_product_color_icon_active : styles.block_product_color_icon}>
                                            <div style={{ backgroundColor: elm.color }}></div>
                                          </div>
                                          <div className={styles.block_product_color_name}>{elm.name}</div>
                                        </div>
                                      )
                                    })}
                                  </div>
                                </div>
                                <div className={styles.block_product_start_description}>
                                  <div className='d-flex align-items-center justify-content-between'>
                                    <div className={styles.block_product_start_description_title}>Размер</div>
                                    <div></div>
                                  </div>
                                  <div className={styles.block_product_sizes}>
                                    {product.variants.sort( (a, b) => {
                                      return Number(a.size) - Number(b.size)
                                    }).map( ( elm, k ) => {
                                      if(!u_sizes.includes( elm.size )) {
                                        u_sizes.push( elm.size )
                                        let var_count = 0
                                        if(elm.stocks != null) elm.stocks.map( ( var_count_el ) => {
                                          var_count+= var_count_el.stock
                                        })
                                        if(var_count == 0) return (
                                          <div onClick={() => this.changeProduct( product.msid, elm.msid )} className={size == elm.size ? styles.block_product_sizes_el_active : styles.block_product_sizes_el_empty} key={k}>{elm.size ? elm.size : `NS`}</div>
                                        )
                                        return (
                                          <div onClick={() => this.changeProduct( product.msid, elm.msid )} className={size == elm.size ? styles.block_product_sizes_el_active : styles.block_product_sizes_el} key={k}>{elm.size ? elm.size : `NS`}</div>
                                        )
                                      }
                                    })}
                                  </div>
                                </div>
                              </>
                            }
                            {'shops' in ajax_data &&
                              <Shops shops={ajax_data.shops} color={variant != null ? color : 'NA'} size={variant != null ? size : ''} product={product} changeProduct={this.changeProduct} />
                            }
                            <Razmeri page_data={page_data} ajax_data={ajax_data} clientWidth={clientWidth} />
                            { ( ( stocks.sklad + stocks.shop ) == 0 ) ?
                              <div className={styles.block_product_start_buttons}>
                                <Button disabled={true} onClick={() => this.addTocart()} className={styles.block_product_start_buttons_buy} variant='dark'>
                                  <div>Добавить в корзину</div>
                                  <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M15.1727 15.5223C14.0633 15.5223 13.1639 16.4217 13.1639 17.5311C13.1639 18.6405 14.0633 19.5398 15.1727 19.5398C16.2821 19.5398 17.1815 18.6405 17.1815 17.5311C17.1815 16.4217 16.2821 15.5223 15.1727 15.5223ZM15.1727 15.5223H7.43286C6.96978 15.5223 6.73781 15.5223 6.54716 15.4399C6.37897 15.3672 6.23306 15.2502 6.12675 15.101C6.0076 14.9337 5.95967 14.7101 5.86481 14.2673L3.39277 2.73113C3.2957 2.27814 3.24651 2.05189 3.12598 1.8827C3.01967 1.73348 2.87379 1.61603 2.7056 1.54335C2.51491 1.46094 2.28423 1.46094 1.82096 1.46094H1.11133M4.12448 4.47409H17.0541C17.7791 4.47409 18.1412 4.47409 18.3845 4.6251C18.5976 4.75739 18.7536 4.96485 18.8217 5.20629C18.8993 5.48192 18.7995 5.82997 18.5986 6.5265L17.2079 11.3475C17.0878 11.764 17.0277 11.9718 16.9058 12.1264C16.7983 12.2628 16.6564 12.3695 16.4955 12.4351C16.3138 12.5091 16.0978 12.5091 15.6669 12.5091H5.86253M6.13324 19.5398C5.02383 19.5398 4.12448 18.6405 4.12448 17.5311C4.12448 16.4217 5.02383 15.5223 6.13324 15.5223C7.24265 15.5223 8.14201 16.4217 8.14201 17.5311C8.14201 18.6405 7.24265 19.5398 6.13324 19.5398Z" stroke="white" strokeOpacity="0.6" strokeWidth="0.964208" strokeLinecap="round" strokeLinejoin="round"/>
                                  </svg>
                                </Button>
                                {/*
                                <Button disabled={true} className={styles.block_product_start_buttons_fast} variant='outline-dark'>Купить сейчас</Button>
                                */}
                                </div>
                            :
                              <div className={styles.block_product_start_buttons}>
                                {count > 0 ?
                                  <ButtonGroup className={styles.block_product_start_buttons_buy_group}>
                                    <Button onClick={() => this.changeCount( Number( count ) - 1 )} variant="dark">
                                      <svg width="17" height="1" viewBox="0 0 17 1" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M0.473145 0.5L16.4999 0.499999" stroke="white" strokeWidth="0.75"/>
                                      </svg>
                                    </Button>
                                    <Button onClick={() => this.addTocart()} variant='dark'>
                                      <div>В корзине x {count} шт</div>
                                    </Button>
                                    <Button onClick={() => this.changeCount( Number( count ) + 1 )} variant="dark">
                                      <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M8.51172 0.5V16.5" stroke="white" strokeWidth="0.75"/>
                                        <path d="M0.5 8.5L16.5268 8.5" stroke="white" strokeWidth="0.75"/>
                                      </svg>
                                    </Button>
                                  </ButtonGroup>
                                :
                                  <Button onClick={() => this.addTocart()} className={styles.block_product_start_buttons_buy} variant='dark'>
                                    <div>Добавить в корзину</div>
                                    <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                                      <path d="M15.1727 15.5223C14.0633 15.5223 13.1639 16.4217 13.1639 17.5311C13.1639 18.6405 14.0633 19.5398 15.1727 19.5398C16.2821 19.5398 17.1815 18.6405 17.1815 17.5311C17.1815 16.4217 16.2821 15.5223 15.1727 15.5223ZM15.1727 15.5223H7.43286C6.96978 15.5223 6.73781 15.5223 6.54716 15.4399C6.37897 15.3672 6.23306 15.2502 6.12675 15.101C6.0076 14.9337 5.95967 14.7101 5.86481 14.2673L3.39277 2.73113C3.2957 2.27814 3.24651 2.05189 3.12598 1.8827C3.01967 1.73348 2.87379 1.61603 2.7056 1.54335C2.51491 1.46094 2.28423 1.46094 1.82096 1.46094H1.11133M4.12448 4.47409H17.0541C17.7791 4.47409 18.1412 4.47409 18.3845 4.6251C18.5976 4.75739 18.7536 4.96485 18.8217 5.20629C18.8993 5.48192 18.7995 5.82997 18.5986 6.5265L17.2079 11.3475C17.0878 11.764 17.0277 11.9718 16.9058 12.1264C16.7983 12.2628 16.6564 12.3695 16.4955 12.4351C16.3138 12.5091 16.0978 12.5091 15.6669 12.5091H5.86253M6.13324 19.5398C5.02383 19.5398 4.12448 18.6405 4.12448 17.5311C4.12448 16.4217 5.02383 15.5223 6.13324 15.5223C7.24265 15.5223 8.14201 16.4217 8.14201 17.5311C8.14201 18.6405 7.24265 19.5398 6.13324 19.5398Z" stroke="white" strokeOpacity="0.6" strokeWidth="0.964208" strokeLinecap="round" strokeLinejoin="round"/>
                                    </svg>
                                  </Button>
                                }
                                {/*
                                <Button onClick={() => this.show_feedback()} className={styles.block_product_start_buttons_fast} variant='outline-dark'>Купить сейчас</Button>
                                */}
                                {variant != null ?
                                  <FeedbackForm
                                    title={`Купить сейчас`}
                                    text={``}
                                    btn={``}
                                    data={[
                                      {
                                        name: `Товар`,
                                        value: variant.name
                                      },
                                      {
                                        name: `Цена`,
                                        value: variant.price
                                      },
                                      {
                                        name: `Цвет`,
                                        value: variant.colorName
                                      },
                                      {
                                        name: `Размер`,
                                        value: variant.size
                                      }
                                    ]}
                                    show={show_feedback}
                                    handleClose={this.close_feedback}
                                  />
                                :
                                <FeedbackForm
                                  title={`Купить сейчас`}
                                  text={``}
                                  btn={``}
                                  data={[
                                    {
                                      name: `Товар`,
                                      value: product.name
                                    },
                                    {
                                      name: `Цена`,
                                      value: product.price
                                    }
                                  ]}
                                  show={show_feedback}
                                  handleClose={this.close_feedback}
                                />
                                }

                              </div>
                            }
                            {page_data.tg &&
                              <div className='w-xl-50 d-flex align-items-center'>
                                <div className={styles.block_product_start_svaz}>
                                  Возникли вопросы? Свяжитесь с нами<br />
                                  по номеру телефона или в Telegram
                                </div>
                                <a href={page_data.tg} target="_blak" className={styles.block_product_start_svaz_btn}>
                                  <svg width="16" height="15" viewBox="0 0 16 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M1.05925 6.76887C1.05925 6.76887 7.74253 3.8049 10.0604 2.76122C10.949 2.34378 13.9622 1.00786 13.9622 1.00786C13.9622 1.00786 15.353 0.423446 15.2371 1.8428C15.1984 2.42727 14.8894 4.47281 14.5803 6.68538C14.1167 9.81637 13.6145 13.2395 13.6145 13.2395C13.6145 13.2395 13.5373 14.1997 12.8805 14.3667C12.2238 14.5337 11.1421 13.7823 10.949 13.6153C10.7944 13.4901 8.05157 11.6115 7.04715 10.693C6.77672 10.4426 6.46768 9.94164 7.08575 9.35716C8.47652 7.97953 10.1377 6.26794 11.1421 5.18254C11.6057 4.68156 12.0692 3.51267 10.1377 4.93202C7.39484 6.97762 4.69062 8.89795 4.69062 8.89795C4.69062 8.89795 4.0725 9.31539 2.91357 8.93966C1.75458 8.564 0.402469 8.06301 0.402469 8.06301C0.402469 8.06301 -0.524636 7.43683 1.05925 6.76887Z" fill="white"/>
                                  </svg>
                                </a>
                              </div>
                            }
                          </>
                        }
                      </div>
                    </div>
                  </div>
                }
              </Container>
              {'product_lists' in ajax_data &&
                <>
                  {ajax_data.product_lists.map( ( list, k ) => {
                    return (
                      <Lists
                        key={k}
                        title={list.title}
                        products={list.products}
                        showInCart={showInCart}
                        in_cart_loading={in_cart_loading}
                        favorite={favorite}
                        changeFavorite={changeFavorite}
                        cart={cart}
                        link={page_data.new_link}
                      />
                    )
                  })}
                </>
              }
            </div>
            :
            <div style={{ height: `800px` }} className='d-none d-lg-flex w-100 align-items-center justify-content-center'>
              <Spinner animation="border" variant="dark" />
            </div>
          }
        </div>
        <RecomendedNg
          title={`НОВЫЕ ПОСТУПЛЕНИЯ`}
          text={`Посмотрите наши последние поступления дизайнерской одежды и подберите свой стиль`}
          showInCart={showInCart}
          in_cart_loading={in_cart_loading}
          favorite={favorite}
          changeFavorite={changeFavorite}
          cart={cart}
          link={page_data.new_link}
          variant={`new`}
          start={ajax_data?.new_products || { page: 1, paginator: [], products: [] }}
        />
      </>
    )
  }
}

Main.propTypes = {
  ajax_data: PropTypes.object,
  page_data: PropTypes.object,
  changeTopSearch: PropTypes.func,
  changeLeftMenuh: PropTypes.func,
  showInCart: PropTypes.func,
  favorite: PropTypes.array,
  changeFavorite: PropTypes.func,
  cart: PropTypes.array,
  in_cart_loading: PropTypes.bool,
  addTocart: PropTypes.func,
  clientWidth: PropTypes.number,
  get: PropTypes.array
}